import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './BottomTabBar.css';

const BottomTabBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;

  // 경로에 따라 활성 탭 결정
  const getActiveTab = () => {
    if (path.startsWith('/store')) return 'store';
    if (path.startsWith('/home')) return 'home';
    if (path.startsWith('/pointshop')) return 'pointshop';
    if (path.startsWith('/community')) return 'community';
    if (path.startsWith('/event')) return 'event';
    return '';
  };
  const activeTab = getActiveTab();

  const handleTabClick = (tab, path) => {
    navigate(path);
  };

  return (
    <div className="footer">
      <div className="footer-container">
        <div className="footer-icon-container" onClick={() => handleTabClick('home', '/home')}>
          <img className={`footer-icon ${activeTab === 'home' ? 'active' : ''}`} src="/footer_home.svg" alt="" />
          <div className="footer-text" style={activeTab === 'home' ? { color: '#f40009' } : {}}>
            홈
          </div>
        </div>
        <div className="footer-icon-container" onClick={() => handleTabClick('store', '/store')}>
          <img className={`footer-icon ${activeTab === 'store' ? 'active' : ''}`} src="/footer_store.svg" alt="" />
          <div className="footer-text" style={activeTab === 'store' ? { color: '#f40009' } : {}}>
            스토어
          </div>
        </div>
        <div className="footer-icon-container" onClick={() => handleTabClick('pointshop', '/pointshop')}>
          <img
            className={`footer-icon ${activeTab === 'pointshop' ? 'active' : ''}`}
            src="/footer_pointshop.svg"
            alt=""
          />
          <div className="footer-text" style={activeTab === 'pointshop' ? { color: '#f40009' } : {}}>
            포인트샵
          </div>
        </div>
        <div className="footer-icon-container" onClick={() => handleTabClick('community', '/community')}>
          <img
            className={`footer-icon ${activeTab === 'community' ? 'active' : ''}`}
            src="/footer_community.svg"
            alt=""
          />
          <div className="footer-text" style={activeTab === 'community' ? { color: '#f40009' } : {}}>
            커뮤니티
          </div>
        </div>
        <div className="footer-icon-container" onClick={() => handleTabClick('event', '/event')}>
          <img className={`footer-icon ${activeTab === 'event' ? 'active' : ''}`} src="/footer_event.svg" alt="" />
          <div className="footer-text" style={activeTab === 'event' ? { color: '#f40009' } : {}}>
            이벤트
          </div>
        </div>
      </div>
    </div>
  );
};

export default BottomTabBar;
